"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncCycleTimes = asyncCycleTimes;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _asyncToArray = require("../$to-array/async-to-array");

var _cycleTimes = require("./cycle-times");

async function* asyncCycleTimes(iterable, n) {
  yield* (0, _cycleTimes.cycleTimes)((await iterable), n);
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncCycleTimes, {
  validateArgs(args) {
    args[1] = (0, _asyncToArray.asyncToArray)(args[1]);
  }

});

exports.default = _default;